import React from "react";
import { connect } from "react-redux";
import { Button, Popup, TextBox, Validator } from "devextreme-react";
import { Tooltip } from "devextreme-react/ui/tooltip";
import validacion from "../../../../../helpers/validaciones";

import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { mailValidation, doChangedMail, updateMyData, doChangePassword } from "../MisDatos/actions";
class ModalMesseges extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.initialState;

    this.emailComponent = React.createRef();
    this.repeatComponent = React.createRef();
    this.currentPassComponent = React.createRef();
    this.passComponent = React.createRef();
    this.repeatPassComponent = React.createRef();
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.mailChanged !== prevProps.mailChanged) {
      if (this.props.mailChanged === true) {
        this.setState({
          messege: `¿Está seguro de asociar tu cuenta al nuevo correo ${this.state.personalData.email} ? \n Tendrás que iniciar sesión nuevamente.`,
          red: false,
          isEmailFormHide: true,
        });
      }
      if (this.props.mailChanged === false) {
        if (this.state.personalData.email !== null) {
          this.setState({
            messege: ` ${this.state.personalData.email}, ya existe en nuestros registros. Por favor, intente con otro correo `,
            red: true,
            isEmailFormHide: false,
            fromIsValid: false,
          });
        }
      }
    }
  }
  get initialState() {
    return {
      fromIsValid: false,
      isEmailFormHide: false,
      messege: null,
      red: false,
      personalData: {
        email: null,
        emailRepeat: null,
        isValidMail: false,
        isValidRepeat: false,

      },
      password: {
        oldPass: null,
        pass: null,
        rePass: null,
        isValidOldPass: false,
        isValidPass: false,
        isValidRepeatPass: false,
      },
      resultPass: false,
      showTooltip: false,
      formPassValid: false,
    };
  }
  resetBuilder() {
    this.setState(this.initialState);
  }

  handleCerrar = () => {
    this.resetBuilder();
    this.props.closeModalCall();
  }


  handleUpdateEmail = () => {
    this.props.dispatch(mailValidation(this.state.personalData.email));
  }
  doUpdateEmail = () => {
    // cambio directamente el mail
    if (this.props.renderForm === "changeEmail") {
      this.props.dispatch(doChangedMail(this.props.profile, this.state.personalData.email, this.props.mailChanged, this.props.UserInfo));
    } else
      if (this.props.renderForm === "alternativeEmail") {
        const profile = this.props.profile;
        profile.AlternativeEmail = this.state.personalData.email;
        this.props.dispatch(updateMyData(profile));
      }

    this.handleCerrar();
  }
  handlePaste = (e) => {
    e.event.preventDefault();
  }
  validationEmail = (e) => {
    if (validacion.validarEmail(e.value.toLowerCase())) {
      return true;
    }
    return false;
  }
  handleChangeEmail(e) {
    const ident = (typeof e === "object") ? e.element.id : "";
    let errorTxt = "";
    const personalData = Object.assign({}, this.state.personalData);
    switch (ident) {
      case "email": {
        if (e.value.length > 50) {
          errorTxt = "El correo supera los 50 carácteres permitidos.";
          personalData.isValidRepeat = false;
        } else if (personalData.emailRepeat) {
          if (e.value.toLowerCase() !== personalData.emailRepeat) {
            errorTxt = "El correo no coincide.";
            personalData.isValidRepeat = false;
            this.repeatComponent.option({
              validationError: { message: errorTxt },
              isValid: personalData.isValidRepeat,
            });
          } else {
            personalData.isValidMail = true;
            personalData.isValidRepeat = true;
            this.repeatComponent.option({
              validationError: { message: errorTxt },
              isValid: personalData.isValidRepeat,
            });
          }
        }


        e.component.option({
          validationError: { message: errorTxt },
          isValid: personalData.isValidMail,
        });

        personalData.email = e.value.toLowerCase();


        break;
      }
      case "emailRepeat": {
        if (e.value !== "") {
          if (!validacion.validarEmail(e.value.toLowerCase())) {
            errorTxt = "Formato correo electrónico inválido.";
            personalData.isValidRepeat = false;
          } else if (e.value.toLowerCase() !== personalData.email) {
            errorTxt = "El correo no coincide.";
            personalData.isValidRepeat = false;
          } else {
            personalData.isValidRepeat = true;
            personalData.isValidMail = true;
            this.emailComponent.option({
              validationError: { message: errorTxt },
              isValid: personalData.isValidMail,
            });
          }
        } else {
          errorTxt = "El correo no puede estar vacio.";
          personalData.isValidRepeat = false;
        }

        e.component.option({
          validationError: { message: errorTxt },
          isValid: personalData.isValidRepeat,
        });
        personalData.emailRepeat = e.value.toLowerCase();

        break;
      }


      default:
        break;
    }
    this.setState({
      personalData,
      fromIsValid: !!((personalData.isValidMail && personalData.isValidRepeat)),
    });
  }
  handleChangePassword(e) {
    const ident = (typeof e === "object") ? e.element.id : "";
    const password = Object.assign({}, this.state.password);
    let errorTxt = "";

    switch (ident) {
      case "oldPass": {
        password.isValidOldPass = true;
        password.isValidPass = true;

        if (e.value !== "") {
          if (!validacion.storngPasswordPattern(e.value)) {
            errorTxt = "Formato contraseña inválido.";
            password.isValidOldPass = false;
          }
        } else {
          errorTxt = "Debe ingresar contraseña actual.";
          password.isValidPass = false;
        }
        if (password.pass) {
          if (e.value === password.pass) {
            errorTxt = "Nueva contraseña no puede ser igual a la antigua.";
            password.isValidPass = false;
          }

          this.passComponent.option({
            validationError: { message: errorTxt },
            isValid: password.isValidPass,
          });
        }
        e.component.option({
          validationError: { message: errorTxt },
          isValid: password.isValidOldPass,
        });

        password.oldPass = e.value;

        break;
      }
      case "pass": {
        if (e.value !== "") {
          password.isValidPass = true;
          password.isValidRepeatPass = true;
          const result = validacion.passValidation(e.value);

          if (!validacion.storngPasswordPattern(e.value)) {
            errorTxt = "Formato contraseña inválido.";
            password.isValidPass = false;
          }
          if (password.oldPass) {
            if (e.value === password.oldPass) {
              errorTxt = "Nueva contraseña no puede ser igual a la antigua.";
              password.isValidPass = false;
            }
          }
          if (password.rePass) {
            if (e.value !== password.rePass) {
              errorTxt = "Nueva contraseña y confirmación de contraseña no coinciden.";
              password.isValidPass = false;
            }

            this.repeatPassComponent.option({
              validationError: { message: errorTxt },
              isValid: password.isValidRepeatPass,
            });
          }
          e.component.option({
            validationError: { message: errorTxt },
            isValid: password.isValidPass,
          });

          password.pass = e.value;
          this.setState({ resultPass: result });
        } else {
          e.component.option({
            validationError: { message: "Nueva contraseña no puede quedar vacia." },
            isValid: false,
          });
        }

        break;
      }
      case "rePass": {
        if (e.value !== "") {
          password.isValidPass = true;
          password.isValidRepeatPass = true;
          password.isValidOldPass = true;
          if (!validacion.storngPasswordPattern(e.value)) {
            errorTxt = "Formato contraseña inválido.";
            password.isValidRepeatPass = false;
          }
          if (password.oldPass) {
            if (password.oldPass === password.pass) {
              errorTxt = "Nueva contraseña no puede ser igual a la antigua.";
              password.isValidPass = false;
              password.isValidRepeatPass = false;
              password.isValidOldPass = false;
            }

            this.passComponent.option({
              validationError: { message: errorTxt },
              isValid: password.isValidPass,
            });
          }
          if (password.pass) {
            if (e.value !== password.pass) {
              errorTxt = "Nueva contraseña y confirmación de contraseña no coinciden.";
              password.isValidRepeatPass = false;
              password.isValidPass = false;
            }
            this.passComponent.option({
              validationError: { message: errorTxt },
              isValid: password.isValidPass,
            });
          }
        } else {
          errorTxt = "Confirmación de contraseña no puede quedar vacía.";
          password.isValidRepeatPass = false;
        }

        e.component.option({
          validationError: { message: errorTxt },
          isValid: password.isValidRepeatPass,
        });
        password.rePass = e.value;

        break;
      }

      default:
        break;
    }
    this.setState({
      password,
      formPassValid: !!((password.isValidPass && password.isValidRepeatPass && password.isValidOldPass)),
    });
  }

  changeMessege = (renderForm) => {
    let messge = "";
    switch (renderForm) {
      case "changeEmail": {
        if (this.state.messege === null) {
          messge = `Tu correo actual es ${this.props.profile.Email}, si lo decides cambiar recuerda que también va a cambiar tu credencial para iniciar sesión la próxima vez.`;
        } else {
          messge = this.state.messege;
        }
        break;
      }
      case "alternativeEmail": {
        if (this.state.messege === null) {
          messge = "Agregar un correo alternativo te permite recuperar cuenta a través de otro correo, como también recibir notificaciones en otra dirección.";
        } else {
          messge = this.state.messege;
        }
        break;
      }
      case "changePassword": {
        messge = this.state.messege;
        break;
      }


      default:
        break;
    }

    return (messge);
  }


  doChangePassword() {
    const Data = {};
    Data.Email = this.props.profile.Email;
    Data.oldPass = this.state.password.oldPass;
    Data.NewPassword = this.state.password.pass;
    Data.NewPasswordConfirmation = this.state.password.rePass;
    this.props.dispatch(doChangePassword(Data));
    this.handleCerrar();
  }
  renderChangePassword = () => (

    <React.Fragment >


      <div className="row">

        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          <h3><p className="text-left">Contraseña Actual</p></h3>
          <TextBox
            id="oldPass"
            placeholder="Contraseña"
            mode="password"
            onValueChanged={this.handleChangePassword}
            maxLength={80}
          />

        </div>
        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          <h3><p className="text-left">Nueva Contraseña</p></h3>
          <Tooltip
            className="tooltip-messege"
            visible={this.state.showTooltip}
            contentRender={() =>
              (

                <React.Fragment>
                  <div className="tooltip-custom-content" >
                    {this.state.resultPass.regxMin === true ?
                      <div className="success"><i className="material-icons">done </i><span className="text">Mínimo 8 caracteres</span> </div>
                      : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Mínimo 8 caracteres</span> </div>
                    }
                  </div>
                  <div className="tooltip-custom-content" >
                    {this.state.resultPass.regxCapital === true ?
                      <div className="success"><i className="material-icons">done </i><span className="text">Mayúsculas</span> </div>
                      : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Mayúsculas</span> </div>
                    }
                  </div>
                  <div className="tooltip-custom-content" >
                    {this.state.resultPass.regxNumber === true ?
                      <div className="success"><i className="material-icons">done </i><span className="text">Números</span> </div>
                      : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Número</span> </div>
                    }
                  </div>
                  <div className="tooltip-custom-content" >
                    {this.state.resultPass.regxSpecialCaracters === true ?
                      <div className="success"><i className="material-icons">done </i><span className="text">Simbolos {"#?!@$%^&*-,.()+:;<>=[^_`{}|~'/"} </span> </div>
                      : <div className="default"> <i className="material-icons">error_outline</i><span className="text">Simbolos {"#?!@$%^&*-,.()+:;<>=[^_`{}|~'/"} </span> </div>
                    }
                  </div>
                </React.Fragment>


              )}
            position="top"
            target="#pass"
          />
          <TextBox
            id="pass"
            placeholder="Contraseña"
            mode="password"
            onValueChanged={this.handleChangePassword}
            maxLength={80}
            valueChangeEvent="input"
            ref={(ref) => ref != null ? this.passComponent = ref.instance : null}
            onFocusIn={() => this.setState({ showTooltip: true })}
            onFocusOut={() => this.setState({ showTooltip: false })}
          />

        </div>
        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          <h3><p className="text-left">Repetir Nueva Contraseña</p></h3>
          <TextBox
            id="rePass"
            placeholder="Repetir Contraseña"
            mode="password"
            ref={(ref) => ref != null ? this.repeatPassComponent = ref.instance : null}
            onPaste={this.handlePaste}
            onValueChanged={this.handleChangePassword}
            maxLength={80}
          />
        </div>
      </div>

    </React.Fragment>
  )

  renderEmailForm = () => (

    <React.Fragment >


      <div className="row">
        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          <h3><p className="text-left">Nuevo correo</p></h3>
          <TextBox
            className="lowercaseText"
            id="email"
            placeholder="Nuevo correo"
            ref={(ref) => ref != null ? this.emailComponent = ref.instance : null}
            onValueChanged={this.handleChangeEmail}
            valueChangeEvent="focusout"
            maxLength={50}
          >
            <Validator
              validationRules={[
                {
                  type: "required",
                  message: "El mail no puede estar vacio.",
                },
                {
                  type: "custom",
                  validationCallback: this.validationEmail,
                  message: "Formato correo electrónico inválido.",
                },

              ]}
            />
          </TextBox>
        </div>
        <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12" >
          <h3><p className="text-left">Repetir nuevo correo</p></h3>
          <TextBox
            className="lowercaseText"
            id="emailRepeat"
            placeholder="Repetir nuevo correo"
            ref={(ref) => ref != null ? this.repeatComponent = ref.instance : null}
            onValueChanged={this.handleChangeEmail}
            onPaste={this.handlePaste}
            valueChangeEvent="focusout"
            value={this.state.personalData.emailRepeat}
            maxLength={50}
          >

          </TextBox>
        </div>

      </div>

    </React.Fragment>
  )

  render() {
    const {
      open,
      title,
      renderForm,

    } = this.props;


    return (
      <Popup
        visible={open}
        dragEnabled={false}
        height={this.state.isEmailFormHide === false ? "400px" : "200px"}
        onHiding={this.handleCerrar}
        width="500px"
        title={title}
        showTitle
        contentRender={() => (
          <div>
            {this.props.isLoading && <LoadingOverlay />}


            <div className="col-12" style={{ justifyContent: "center" }}>
              <div
                style={{
                  color: (this.state.red ? "red" : "#787878"),
                  width: "100%",
                  textAlign: "center",
                  fontSize: 12,
                  whiteSpace: "pre-line",
                }}
              >
                {this.changeMessege(renderForm)}
              </div>
            </div>

            {(renderForm === "changeEmail" || renderForm === "alternativeEmail") && this.state.isEmailFormHide === false && this.renderEmailForm()}
            {(renderForm === "changePassword") && this.state.isEmailFormHide === false && this.renderChangePassword()}
            <div className="button-row">
              <div>
                <Button
                  text="Cerrar"
                  type="normal"
                  onClick={this.handleCerrar}
                />
              </div>
              {/* boton changemail */}
              <div>
                {renderForm === "changeEmail" || renderForm === "alternativeEmail" ?
                  <Button
                    text={this.state.isEmailFormHide === false ? "Aceptar" : "Cambiar"}
                    type="success"
                    onClick={this.state.isEmailFormHide === false ? this.handleUpdateEmail : this.doUpdateEmail}
                    disabled={!(this.state.fromIsValid)}
                  />
                  :
                  null
                }
                {renderForm === "changePassword" &&
                  <Button
                    text="Cambiar"
                    type="success"
                    disabled={!(this.state.formPassValid)}
                    onClick={() => this.doChangePassword()}

                  />}
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.misDatos.isLoading,
  UserInfo: state.global.userData,
  profile: state.misDatos.profile,
  mailChanged: state.misDatos.mailChanged,
  preventNavigation: state.global.preventNavigation,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalMesseges);
